<template>
  <!--
    Canonical V2 modal example. Reference this file when building new modals.
    Pattern: <v-dialog content-class="sc-modal sc-modal--sm"> with .sc-modal__card
    inside. All structural styling comes from _modal.scss (sc-modal__*); the
    scoped <style> block only carries this component's activator-button tweak.
  -->
  <v-dialog
    v-model="dialog"
    max-width="500"
    content-class="sc-modal sc-modal--sm"
  >
    <template v-slot:activator="{ on, attrs }">
      <template v-if="isEditarForm">
        <div class="table-action-box" v-bind="attrs" v-on="on">
          <v-icon small>mdi-pencil</v-icon>
          <span class="table-action-label">Editar</span>
        </div>
      </template>
      <template v-else>
        <v-btn small color="primary" class="conta-add-btn" v-bind="attrs" v-on="on">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </template>
    </template>

    <v-card v-if="dialog" flat class="sc-modal__card">
      <v-btn icon class="sc-modal__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <!-- Header -->
      <div class="sc-modal__header">
        <v-icon color="primary" class="mr-3">{{ isEditarForm ? 'mdi-account-edit' : 'mdi-account-cancel' }}</v-icon>
        <div>
          <span class="sc-modal__title">{{ isEditarForm ? 'Editar conta bloqueada' : 'Bloquear conta' }}</span>
          <span class="sc-modal__subtitle">A conta será filtrada das colaborações</span>
        </div>
      </div>

      <!-- Form -->
      <div class="sc-modal__body">
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Conta</label>
          <v-text-field
            solo
            flat
            dense
            background-color="surface_tertiary"
            placeholder="Ex: @usuario, nome do canal..."
            v-model="dsc_colaborador_user"
            hide-details="auto"
          />
        </div>
        <div class="sc-modal__field">
          <label class="sc-modal__field-label">Rede social</label>
          <v-select
            solo
            flat
            dense
            background-color="surface_tertiary"
            v-model="dsc_fonte_colaboracao"
            :items="redes_sociais"
            placeholder="Selecione a rede social"
            hide-details="auto"
          />
        </div>
      </div>

      <!-- Footer -->
      <div class="sc-modal__footer">
        <v-btn text @click="close" class="modal-btn-cancel">Cancelar</v-btn>
        <v-btn
          color="primary"
          :loading="loading"
          @click.prevent="isEditarForm ? editarContaBloqueada() : inserirContaBloqueada()"
          class="modal-btn-confirm"
        >
          <v-icon small class="mr-1">mdi-check</v-icon>
          {{ isEditarForm ? 'Atualizar' : 'Salvar' }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiClient } from '@/services/api';
import { capitalizeString } from '@/utils/capitalizeString';

export default {
  name: "ModalAdicionarOuEditarContaBloqueada",
  props: {
    getContasBloqueadas: Function,
    editFormData: Object,
    isEditarForm: Boolean,
  },
  data() {
    return {
      loading: false,
      dsc_colaborador_user: "",
      redes_sociais: ['Twitter', 'Whatsapp', 'Canal-Globo'],
      dsc_fonte_colaboracao: "",
      dialog: false,
    };
  },
  watch: {
    dialog(open) {
      if (open) this.seedForm();
    },
  },
  created() {
    this.seedForm();
  },
  methods: {
    seedForm() {
      if (this.isEditarForm && this.editFormData) {
        this.dsc_colaborador_user = this.editFormData.dsc_colaborador_user;
        this.dsc_fonte_colaboracao = capitalizeString(this.editFormData.dsc_fonte_colaboracao);
      } else {
        this.dsc_colaborador_user = "";
        this.dsc_fonte_colaboracao = "";
      }
    },
    async inserirContaBloqueada() {
      try {
        this.loading = true;

        if (this.dsc_colaborador_user.trim() === '') {
          return this.$toast.error('Campo conta bloqueada é obrigatório.');
        }

        if (this.dsc_fonte_colaboracao.trim() === '') {
          return this.$toast.error('Escolha qual a rede social da conta que deseja bloquear.');
        }

        const payload = {
          dsc_colaborador_user: this.dsc_colaborador_user,
          dsc_fonte_colaboracao: this.dsc_fonte_colaboracao.toLowerCase(),
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        };

        const response = await apiClient.post('/inserirContaBloqueada', payload);

        if (response.status === 200) {
          await this.getContasBloqueadas();
          this.$toast.success('Conta bloqueada adicionada com sucesso.');
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || 'Erro ao bloquear conta.');
      } finally {
        this.loading = false;
      }
    },
    async editarContaBloqueada() {
      try {
        this.loading = true;

        if (this.dsc_colaborador_user.trim() === '') {
          return this.$toast.error('Campo conta bloqueada é obrigatório.');
        }

        if (this.dsc_fonte_colaboracao.trim() === '') {
          return this.$toast.error('Escolha qual a rede social da conta que deseja bloquear.');
        }

        const payload = {
          dsc_colaborador_user: this.dsc_colaborador_user,
          dsc_fonte_colaboracao: this.dsc_fonte_colaboracao.toLowerCase(),
          cod_conta_bloqueada: this.editFormData.cod_conta_bloqueada,
        };

        const response = await apiClient.patch('/editarContasBloqueadas', payload);

        if (response.status === 200) {
          await this.getContasBloqueadas();
          this.$toast.success('Conta bloqueada editada com sucesso.');
          this.close();
        }
      } catch (error) {
        this.$toast.error(error.response?.data?.msg || 'Erro ao editar conta.');
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.dialog = false;
      this.loading = false;
      this.dsc_colaborador_user = this.isEditarForm ? this.editFormData.dsc_colaborador_user : '';
      this.dsc_fonte_colaboracao = this.isEditarForm ? capitalizeString(this.editFormData.dsc_fonte_colaboracao) : '';
    },
  },
};
</script>

<style lang="scss" scoped>
// Modal structure comes from _modal.scss (sc-modal__*). This block only
// styles this component's activator button — kept scoped because the
// "Adicionar" button is local to the table-action context.
.conta-add-btn {
  text-transform: none;
  font-weight: var(--sc-weight-semi);
  letter-spacing: 0;
  border-radius: var(--sc-radius-md);
}
</style>
